import React from 'react'
import Filtro from '../comum/Filtro'
import FiltrosAdicionadosAgencia from './FiltrosAdicionadosAgencia'
import FiltroAgencia from './FiltroAgencia'
import PainelFiltragem from '../comum/PainelFiltragem'

export const PainelFiltroAgencia = () => (
  <Filtro PainelFiltro={FiltroAgencia}/>
);

const PainelFiltrosAgencia = () => (
  <PainelFiltragem
    Filtro={PainelFiltroAgencia}
    FiltrosAdicionados={FiltrosAdicionadosAgencia}/>
)

export default PainelFiltrosAgencia
